import { useState } from "react";
import lodash, { isEmpty } from "lodash";
import { MoreVertical } from "react-feather";
import { useDropzone } from "react-dropzone";
import { CardImg } from "reactstrap";

const EditProductImage = ({
  image,
  updatedImage,
  updateImage,
  deleteImage,
  tab,
}) => {
  const [error, setError] = useState({});
  const [openInfoSearch, setOpenInfoSearch] = useState(false);
  const [thumbnailDropdown, setThumbnailDropdown] = useState(false);

  const { getRootProps, getInputProps } = useDropzone({
    maxFilesize: 1,
    maxFiles: 1,
    minSize: 0,
    maxSize: 1048576 * 2,
    accept: "image/jpeg, image/png, image/jpg",
    onDrop: (acceptedFiles, fileRejections) => {
      if (acceptedFiles.length) {
        updateImage(
          Object.assign(acceptedFiles[0], {
            preview: URL.createObjectURL(acceptedFiles[0]),
          })
        );
        setError({});
      }
      const fileErrors = lodash.get(fileRejections, "[0].errors[0]", undefined);
      if (fileErrors) {
        setError(fileErrors);
      }
    },
  });

  const imageStyles = {
    transition: "border .24s ease -in -out",
    padding: "5px 10px",
  };

  return (
    <div
      onMouseLeave={() => {
        setOpenInfoSearch(false);
        setThumbnailDropdown(false);
      }}
      onMouseEnter={() => setOpenInfoSearch(true)}
    >
      {!isEmpty(error) && (
        <div style={{ color: "red" }} className="FileErrorMessage text-center">
          File size Must be less than 2MB
        </div>
      )}
      {tab !== "Competition" && (image || updatedImage) && openInfoSearch && (
        <span
          style={{
            background: "#808080",
            borderRadius: "50%",
            padding: "1.5px 4px",
            position: "absolute",
            zIndex: 1,
            right: "1px",
          }}
        >
          <MoreVertical
            size={20}
            color="white"
            onClick={() => setThumbnailDropdown(!thumbnailDropdown)}
          />
        </span>
      )}
      {(image || updatedImage) && thumbnailDropdown && (
        <div
          style={{
            background: "#808080",
            borderRadius: "5px",
            position: "absolute",
            zIndex: 1,
            right: "15px",
            top: "15px",
            color: "white",
          }}
        >
          <div {...getRootProps()} style={imageStyles}>
            <input {...getInputProps()} />
            <div role="button">Change</div>
          </div>

          <div
            style={{ padding: "5px 10px", cursor: "pointer" }}
            onClick={() => deleteImage()}
          >
            Delete
          </div>
        </div>
      )}
      {image && !updatedImage && (
        <CardImg style={{ maxHeight: "250px" }} src={image} />
      )}
      {updatedImage && (
        <CardImg style={{ maxHeight: "250px" }} src={updatedImage.preview} />
      )}
      {!image && !updatedImage && (
        <div style={{ cursor: "pointer" }}>
          <div
            {...getRootProps({ className: "dropzone" })}
            style={{ transition: "border .24s ease -in -out" }}
          >
            <input {...getInputProps()} />
            <div className="p-4 text-center">
              <CardImg
                style={{ maxHeight: "200px", padding: "3rem 5rem" }}
                src={
                  require("@src/assets/images/vyrill/products/edit-product.png")
                    .default
                }
              />
              <p>Drag & Drop file or Browse</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default EditProductImage;
